/**
 * @file ColorPickerDialog.tsx
 * @description Окно цвета роли (phase19.16 Р1; uiux-design-r1 §1 «Окно
 * цвета»; SB8, SB9): заголовок с ролью, «Где используется» и образец роли
 * `ColorSample` (кнопка, ссылка, бейдж на фоне страницы, контраст). Тело —
 * общее с полем цвета конструктора (`ColorDialogBody`, партия SB120;
 * uiux-sb120-fields §3): оттенок, код, пипетка, цвета сайта, «Последние».
 * На телефоне — на весь экран. Цвет применяется по «Готово».
 */

import { SITE_COLOR_ROLE_INFO, type SiteColorRole, type SiteColors } from "@chaiberi/shared";

import { ColorDialog } from "../../site-fields/ColorDialog";
import { ColorSample } from "./ColorSample";

interface Props {
  role: SiteColorRole | null;
  colors: SiteColors;
  onClose: () => void;
  onDone: (role: SiteColorRole, hex: string) => void;
}

export function ColorPickerDialog({ role, colors, onClose, onDone }: Props) {
  const info = role ? SITE_COLOR_ROLE_INFO[role] : null;
  return (
    <ColorDialog
      initial={role ? colors[role] : null}
      title={`Цвет: ${info?.label ?? ""}`}
      description={`Где: ${info?.usedFor ?? ""}`}
      mode="text"
      colors={colors}
      sample={false}
      // Образец роли — в цветах черновика с новым цветом.
      extra={(value, setValue) => (role ? <ColorSample role={role} colors={{ ...colors, [role]: value }} onApply={setValue} /> : null)}
      onClose={onClose}
      onDone={(hex) => role && onDone(role, hex)}
    />
  );
}
